
<template>
  <div>
    <header class="main-content--header">
      <h4>Reports</h4>
    </header>
    <section class="main-content--body">
      <div class="wrapper-md">
        <div class="main-content--panel">
          <div class="panel--top">
            <div class="columns">
              <div class="column">
                <router-view></router-view>
              </div>
              <div class="column">
                <div class="panel--bottom">
                  <h3>Today - <span>{{todaytime}}</span></h3>
                  <today-chart :chart-data="datasetsfull" :height="280" :options="{responsive: false, maintainAspectRatio: false}"></today-chart>
                </div>
              </div>
            </div>
          </div>
          <div class="users--table">
            <p class="text-left m-b-md">Your daily reports</p>
            <table>
              <thead>
              <tr>
                <th>Duration</th>
                <th>Date</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in summaryreports">
                <td>{{item.time}}</td>
                <td>{{item.date}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import ReportsCharts from '@/components/ReportsCharts'
  import TodayChart from '@/components/TodayChart'
  import axios from 'axios'
  import moment from 'moment'
  import { store } from '../store/store';

  export default {
    name: 'Reports',
    components: { ReportsCharts, TodayChart },
    data () {
        return {
          todaytime: '',
          drr: '',
          summaryreports: null,
        }
    },
    head: {
      title: {
        inner: 'Reports',
        separator: '-',
        complement: 'Worklogs'
      },
    },
    beforeRouteEnter (to, from, next) {
      let _begintoday = moment().format("Y-MM-D") + " 00:00:00";
      let _endtoday = moment().format("Y-MM-D") + " 23:59:59";
      let today = moment().format("Y-MM-D") + " 23:59:59";

      function secondsToHumanize (time) {
        time = time + '000'
        time = Number(time)
        time = moment.duration(time).humanize();
        return time
      }

      axios.get('https://api.kuzcoapp.com/api/v1/report?start=' + _begintoday + '&end=' + _endtoday)
        .then( function (response) {
          let _totaltime = response.data.data.total_time

          let _today = Math.round(( _totaltime/ (24*60*60)) * 100)
          let _notsignedin = Math.round(100 - _today)
          let _chartdata = [_today, _notsignedin]


          next(vm => {
            vm.todaytime = secondsToHumanize(_totaltime)
            store.commit('_todaychart', _chartdata)
          })

        })
        .catch( function (error) {
          next(false)
          console.log(error);
        })
      axios.get('https://api.kuzcoapp.com/api/v1/report?start=2017-01-01&end=2020-01-01')
        .then( function (response) {
          //console.log(response.data.data.reports)
          let _reports = response.data.data.reports
          let _rep = {}
          for (var i in _reports) {
            var _time = _reports[i].time
            var _date = _reports[i].date
            _time = secondsToHumanize(_time)
            _date = moment(_date).format('MMMM Do YYYY')
            _rep[i] = {
              date: _date,
              time: _time
            }
          }
          next(vm => {
            vm.summaryreports = _rep;
          })

        })
        .catch( function (error) {
          console.log(error)
        })
    },
    watch: {
      $route () {
        let _begintoday = moment().format("Y-MM-D") + " 00:00:00";
        let _endtoday = moment().format("Y-MM-D") + " 23:59:59";
        let today = moment().format("Y-MM-D") + " 23:59:59";
        let self = this;
        function secondsToHumanize (time) {
          time = time + '000'
          time = Number(time)
          time = moment.duration(time).humanize();
          return time
        }
        axios.get('https://api.kuzcoapp.com/api/v1/report?start=' + _begintoday + '&end=' + _endtoday )
          .then( function (response) {
            let _totaltime = response.data.data.total_time

            let _today = Math.round((_totaltime/ (24*60*60)) * 100)
            let _notsignedin = Math.round(100 - _today)
            let _chartdata = [_today, _notsignedin]

            self.todaytime = secondsToHumanize(_totaltime)
            store.commit('_todaychart', _chartdata)
          })
          .catch( function (error) {
            console.log(error)
          })
        axios.get('https://api.kuzcoapp.com/api/v1/report?start=2017-01-01&end=2020-01-01')
          .then( function (response) {
            //console.log(response.data.data.reports)
            let _reports = response.data.data.reports
            let _rep = {}
            for (var i in _reports) {
              var _time = _reports[i].time
              var _date = _reports[i].date
              _time = secondsToHumanize(_time)
              _date = moment(_date).format('MMMM Do YYYY')
              _rep[i] = {
                date: _date,
                time: _time
              }
            }
            self.summaryreports = _rep;
          })
          .catch( function (error) {
            console.log(error)
          })
      }
    },
    computed: {
      datasetsfull () {
        return {
          labels: ['Signed In(%)', 'Not Signed In(%)'],
          datasets: [
           {
             label: 'Hours Logged In',
             backgroundColor: [
               '#40cf97',
               '#3D484F'
             ],
             data: store.state.todaychart
           }
         ]
        }
      },
      todaychart () {
        return store.state.todaychart
      },
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  $themecolor: #4671fb;
  $oldthemecolor: #3e454f;
  $kuzcogreen: #40CF97;
  .panel--top {
    margin-top: 30px;
    h3 {
    font-size: 20px;
    margin-bottom: 20px;
      span {
        font-family: "Proxima Bold";
      }
    }
  }
  .panel--bottom {
    margin-left: auto;
    margin-right: auto;
    display: table;
    h3 {
      font-size: 20px;
      margin-bottom: 20px;
      text-align: center;
      span {
        font-family: "Proxima Bold";
      }
    }
  }
  .users--table {
    margin-top: 50px;
    p {
      font-size: 20px;
    }
  }
  table {
    font-size: 14px;
  }
  th {
    padding: 15px;
    border-bottom: 1px solid #D7E2E9;
  }
  td {
    padding: 15px;
    border-top: 1px solid #D7E2E9;
  }
</style>



// WEBPACK FOOTER //
// Reports.vue?07637e74